<template>
  <div class="authCard">
    <el-row
      v-if="!this.$slots.default"
      class="authCard__row"
      type="flex"
      justify="center"
      align="stretch"
    >
      <el-col
        class="authCard__row-left"
        :class="{ inverted: inverted === 'left' || inverted === 'both' }"
        :xs="24"
        :sm="24"
        :md="12"
      >
        <slot name="left" />
      </el-col>
      <el-col
        class="authCard__row-right"
        :class="{ inverted: inverted === 'right' || inverted === 'both' }"
        :xs="24"
        :sm="24"
        :md="12"
      >
        <slot name="right" />
      </el-col>
    </el-row>
    <slot />
  </div>
</template>

<script>
export default {
  name: "AuthCard",
  props: {
    inverted: {
      type: String,
      default: null
    }
  }
}
</script>

<style lang="scss" scoped>
$c: '.authCard';

#{$c} {
  margin-bottom: 5px;

  #{$c}__row {
    flex-wrap: wrap;
    align-items: stretch;

    #{$c}__row-left,
    #{$c}__row-right {
      &.inverted {
        background-color: $--color-secondary;
        color: #ffffff !important;
      }
    }
  }
}
</style>